import PropTypes from 'prop-types'
import { CourseSearchResultsQuery } from '@components/course-search-results'
import GolfCoursesLayout from '@layouts/courses/courses-results-layout'
import { NextSeo } from 'next-seo'
import defaults from '@config/defaults'
import { StatesQuery } from '@components/states'

const GolfCoursesPage = (props) => {
  const {
    query,
  } = props

  const data = {
    breadcrumb: ['Courses', 'Search Results'],
    query,
  }

  return (
    <>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
      />
      <GolfCoursesLayout data={data}>
        <CourseSearchResultsQuery query={query} />
      </GolfCoursesLayout>
      <StatesQuery />
    </>
  )
}

GolfCoursesPage.propTypes = {
  query: PropTypes.shape({
    searchText: PropTypes.string,
  }),
}

GolfCoursesPage.defaultProps = {}

export default GolfCoursesPage
